/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { IProjectSettingTab } from '../interfaces/project-settings';
import { DATA_SOURCES_TITLE, TIME_AND_SCHEDULE_TITLE } from '@touchplan/strings';

export const DATA_SOURCES_ROUTE = 'data-sources';
export const TIME_SCHEDULE_ROUTE = 'time-and-schedule';

export const DATA_SOURCES_TAB: IProjectSettingTab = {
	title: DATA_SOURCES_TITLE,
	route: DATA_SOURCES_ROUTE,
	isAdminOnly: true,
};

export const TIME_SCHEDULE_TAB: IProjectSettingTab = {
	title: TIME_AND_SCHEDULE_TITLE,
	route: TIME_SCHEDULE_ROUTE,
	isAdminOnly: true,
};
